export default "\n<div class=\"loadingio-spinner-rolling-iant5n3706r\"><div class=\"ldio-eaexvssewb9\">\n<div></div>\n</div></div>\n"